import { CustomEventWithoutDetail, type Html, html, on, rune, View } from 'rune-ts';
import klass from './CreatorCheckBoxes.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';

export class OpenTermsModalEvent extends CustomEventWithoutDetail {}

export class CreatorCheckBoxes extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const agree_privacy = is_mobile
      ? html.preventEscape(ET(`mps2::ad_res::mo_agree_privacy`))
      : html.preventEscape(ET(`mps2::ad_res::agree_privacy`));

    return html`
      <div class="${klass.form_checks}">
        <div class="${klass.form_check}">
          <input type="checkbox" name="check_all" id="creator_advance_reservation_checkbox_agree_all" />
          <label
            for="creator_advance_reservation_checkbox_agree_all"
            class="${typoPcMo({ is_mobile, pc: '16_bold', mo: '14_bold' })}"
            >${ET('mps2::ad_res::agree_all')}</label
          >
        </div>
        <div class="${klass.form_check}">
          <input type="checkbox" name="terms" id="creator_advance_reservation_checkbox_agree_terms" />
          <label
            for="creator_advance_reservation_checkbox_agree_terms"
            class="${klass.agree_desc} ${typoPcMo({ is_mobile, pc: '16_medium', mo: '14_medium' })}"
          >
            <span class="${klass.blue}">${ET('mps2::ad_res::necessary')}</span>
            ${agree_privacy}
          </label>
          <div class="${klass.btn_privacy_pop}">${ET('mps2::ad_res::view')}</div>
        </div>
        <div class="${klass.form_check}">
          <input type="checkbox" name="privacy" id="creator_advance_reservation_checkbox_agree_privacy" />
          <label
            for="creator_advance_reservation_checkbox_agree_privacy"
            class="${typoPcMo({ is_mobile, pc: '16_medium', mo: '14_medium' })}"
            ><span class="${klass.blue}">${ET('mps2::ad_res::necessary')}</span>
            ${ET('mps2::ad_res::agree_terms')}
          </label>
        </div>
      </div>
    `;
  }

  @on('change', '[type="checkbox"]')
  changeCheckbox(e) {
    const $target = e.currentTarget;
    const $checkAll = this.element().querySelector('[name=check_all]') as HTMLInputElement;
    const $terms = this.element().querySelector('[name=terms]') as HTMLInputElement;
    const $privacy = this.element().querySelector('[name=privacy]') as HTMLInputElement;

    if ($target.name === 'check_all') {
      $terms.checked = $target.checked;
      $privacy.checked = $target.checked;
    } else {
      $checkAll.checked = $terms.checked && $privacy.checked;
    }
  }

  @on('click', `.${klass.btn_privacy_pop}`)
  openTermsModal() {
    this.dispatchEvent(OpenTermsModalEvent, { bubbles: true });
  }

  isValidate() {
    const $checkAll = this.element().querySelector('[name=check_all]') as HTMLInputElement;
    return $checkAll.checked;
  }
}
